import store from '@/store'

export function showAlertError (error) {
  store.dispatch('alert/setAlertError', error.message)
}

export function showAlertSuccess (message) {
  store.dispatch('alert/setAlertSuccess', message)
}

export function showAlertWarning (message) {
  store.dispatch('alert/setAlertWarning', message)
}
